// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ae323337","389":"27eb45ed","732":"eb2a9aa5","977":"94ada1b3"}[chunkId] + ".chunk.js";
};